// Bound catalogue reads only. Billing, auth and signed audio keep their own rules.
export async function readSessionCatalogue(query) {
  const controller = new AbortController()
  let timer
  try {
    return await Promise.race([
      Promise.resolve(query.abortSignal(controller.signal)),
      new Promise(resolve => {
        timer = setTimeout(() => {
          resolve({ data: null, error: { message: 'Session catalogue read timed out' } })
          controller.abort()
        }, 8_000)
      }),
    ])
  } finally {
    clearTimeout(timer)
  }
}

// App Review 2.1: native builds list and open only sessions with audio. The web keeps its "Coming soon" rows.
export const shownInBuild = (session, mode = import.meta.env.MODE) =>
  mode !== 'native' || Boolean(session.has_audio ?? session.audio_url)
